import PropTypes from 'prop-types';

import classNames from 'classnames';

const Row = ({ label, value, isInput }) => (
  <div className={classNames(
    "curve-modal__row",
    { "curve-modal__row--is-input": isInput }
  )}>
    <div className="curve-modal__row__key">
      {label}:
    </div>
    <div className="curve-modal__row__value">
      {value}
    </div>
  </div>
)

Row.defaultProps = {
  isInput: false
}

Row.propTypes = {
  isInput: PropTypes.bool,
  label: PropTypes.string.isRequired,
  value: PropTypes.any.isRequired,
}


export default Row;